import React from "react";
import ReactDOM from "react-dom";

import core from "~/core/scripts";
import "../styles/index.styl";

import LatestWeek from "./LatestWeekNumber";
import Chart from "./Chart";
import MultiCharts from "./MultiCharts";
import { colorSteps } from "./config";

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

ReactDOM.render(
  <LatestWeek colorSteps={colorSteps} />,
  document.getElementById("latestweek")
);
ReactDOM.render(
  <Chart colorSteps={colorSteps} />,
  document.getElementById("chart")
);
ReactDOM.render(
  <MultiCharts colorSteps={colorSteps} />,
  document.getElementById("multicharts")
);

const lastupdateElm = document.querySelector(".lastupdate");
const lastupdate = new Date();
lastupdate.setDate(lastupdate.getDate());
lastupdateElm.textContent = `${lastupdate.getDate()}.${
  lastupdate.getMonth() + 1
}.${lastupdate.getFullYear()}`;

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === "development") {
  // enable livereload for index html
  require("file-loader!../index.html");

  // if (location.pathname.includes('.html')) {
  //   const fileToLoad = location.pathname.replace('.html', '.js');
  //   try {
  //     require(`../layout-samples${fileToLoad}`);
  //   } catch(e) {
  //     console.log(e);
  //     console.log(`[Starterkit] no file found ${fileToLoad}`);
  //   }
  // }
}
